import { Slide } from "@jelly/lesson";
import config from "appConfig";

import { task as task01 } from "../../../../../task/course-04/lesson-25/task-01";

const task: Slide = {
  titleHtml:
    "The following figures show the real and the imaginary part of the impedance Z = U/I - Bℓ'xV/I,<br>where U, I, and V are measured voltage, current, and velocity, and Bℓ' is an<br>estimated value of Bℓ. Find the correct value of Bℓ.",
  description: "Fill in the value.",
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [4, 1],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/25/task/task-1.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        ],
      ],
    },
  },
};

export default task;
